import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " सौ. रुपाली गणेश ठवकर ", designation: "ग्रामपंचायत गावसुत ",  imageUrl: "/images/rupali.jpeg" },
  { name: "श्री.शामराव महादेवराव येवले", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/shamrao.jpeg" },
  { name: "सौ.सविता राजकुमार मसराम", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/savita.jpeg" },
  { name: "सौ.ज्योती मनोज नान्हे", designation: "गट ग्रामपंचायत गावसुत", imageUrl: "/images/joti.jpeg" },
  { name: "सौ. वैशाली स्वप्निल ठवकर", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/vaishali.jpeg" },
  { name: "श्री. दर्शन अंकुश गणवीर", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/darshan.jpeg" },
   { name: "श्री. अजय मधुकर मूल", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/ajay.jpeg" },
    { name: "सौ. दर्शना जगदीश गणवीर", designation: "गट ग्रामपंचायत गावसुत",  imageUrl: "/images/darshanaa.jpeg" },
  
  ];

const karmachariMembers = [
  { name: "देवानंद रामकृष्ण नान्हे", designation: " ग्रामपंचायत कर्मचारी ",  imageUrl: "/images/devanand.jpeg" },
  { name: "श्री. प्रतिक परसराम शिंदे", designation: "पानी पुरवठा  कर्मचारी",   imageUrl: "/images/pratik.jpeg" },
  /*{ name: "-- ", designation: "संगणक प्ररिचालक गावसुत",   imageUrl: "/images/-.jpeg" },
  { name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone"> {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2026 Gram Panchayat — All Rights Reserved.
        
      </div>
    </div>
  );
};

export default GPTeam;
